import { render } from "./slidesticker-23.vue?vue&type=template&id=b680a59c&scoped=true"
import script from "./slidesticker-23.vue?vue&type=script&lang=js"
export * from "./slidesticker-23.vue?vue&type=script&lang=js"

import "./slidesticker-23.vue?vue&type=style&index=0&id=b680a59c&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b680a59c"]])

export default __exports__